"use client";

import { useState } from "react";
import { reportListing } from "@/lib/client/sentry";
import { useUser } from "@clerk/nextjs";
import { Select, Textarea, Title, Text, Button, Box as MantineBox } from "@mantine/core";
import Modal from "@/components/Modal";

import styles from "./styles.module.scss";

interface Props {
  isOpen: boolean;
  toggleOpen: () => void;
  listingId?: number;
}

const reasons = [
  "Doubled up item",
  "Mislabeled item",
  "Fraudulent activity",
  "Broken link",
  "Other",
];

const ReportListingModal = ({ isOpen, toggleOpen, listingId }: Props) => {
  const { user } = useUser();
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");

  const handleReport = () => {
    reportListing(listingId, reason + (otherReason ? `: ${otherReason}` : ""), user?.id);
    toggleOpen();
    setReason("");
    setOtherReason("");
  };

  return (
    <Modal isOpen={isOpen} closeModal={toggleOpen} zIndex={9000}>
      <MantineBox className={styles.reportListingModal}>
        <Title order={2}>Report Listing</Title>
        <Text size="sm">Thank you for helping us improve our platform.</Text>
        <Select
          label="Reason for reporting"
          placeholder="Select a reason"
          data={reasons.map((r) => ({ value: r, label: r }))}
          value={reason}
          onChange={(value) => setReason(value || "")}
          comboboxProps={{ withinPortal: true, zIndex: 9001 }}
        />
        {reason === "Other" && (
          <Textarea value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
        )}
        <Button onClick={handleReport} variant="primary">
          Submit Report
        </Button>
      </MantineBox>
    </Modal>
  );
};

export default ReportListingModal;
